// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-SuspenseFallback-styles--fallback--G6hBL {
  height: 45px;
  padding-top: 20px;
  position: relative;
}
.src-components-SuspenseFallback-styles--fallback--G6hBL::before {
    content: '';
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #e8eaf0;
  }
.src-components-SuspenseFallback-styles--fallback--G6hBL.src-components-SuspenseFallback-styles--withoutBorder--VgFnk::before {
      content: none;
    }
.src-components-SuspenseFallback-styles--fallback--G6hBL.src-components-SuspenseFallback-styles--fullPage--HG13X::before {
      content: none;
    }
.src-components-SuspenseFallback-styles--fallback--G6hBL.src-components-SuspenseFallback-styles--fullPage--HG13X {
    flex: 1 1;

    /* NOTE 70px - высота топлайна */
    height: calc(100vh - 70px);
    padding-top: 0;
  }
`, "",{"version":3,"sources":["webpack://./src/components/SuspenseFallback/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AAyBpB;AAvBE;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;EAC3B;AAGE;MACE,aAAa;IACf;AAFA;MACE,aAAa;IACf;AAGF;IACE,SAAO;;IAEP,gCAAgC;IAChC,0BAA0B;IAC1B,cAAc;EAChB","sourcesContent":[".fallback {\n  height: 45px;\n  padding-top: 20px;\n  position: relative;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -1px;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background-color: #e8eaf0;\n  }\n\n  &.withoutBorder, &.fullPage {\n    &::before {\n      content: none;\n    }\n  }\n\n  &.fullPage {\n    flex: 1;\n\n    /* NOTE 70px - высота топлайна */\n    height: calc(100vh - 70px);\n    padding-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fallback": `src-components-SuspenseFallback-styles--fallback--G6hBL`,
	"withoutBorder": `src-components-SuspenseFallback-styles--withoutBorder--VgFnk`,
	"fullPage": `src-components-SuspenseFallback-styles--fullPage--HG13X`
};
module.exports = ___CSS_LOADER_EXPORT___;
